/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/headerCumbs.scss';

import React from 'react';

import {HeaderCrumb} from '../../../util/interfaces';

import {PureComponent} from 'react';

import {CustomAppEvent, navigate, WithEvents} from '@dvrd/dvr-controls';

import classNames from 'classnames';

const MAX_VISIBLE = 4;

interface State {
    crumbs: HeaderCrumb[];
}

export default class HeaderCrumbs extends PureComponent<any, State> {
    private readonly event: CustomAppEvent;

    constructor(props: any) {
        super(props);
        this.event = {eventName: 'onSetCrumbs', handler: this.onSetCrumbs};
        this.state = {
            crumbs: []
        };
    }

    onClickCrumb = (crumb: HeaderCrumb) => () => {
        if (crumb.route) navigate(crumb.route);
    };

    onSetCrumbs = (crumbs: HeaderCrumb[]) => {
        this.setState({crumbs});
    };

    getVisibleCrumbs = (): Array<HeaderCrumb | null> => {
        const {crumbs} = this.state;
        if (crumbs.length <= MAX_VISIBLE) return crumbs;
        // first + ... + last (MAX_VISIBLE - 2)
        const tail = crumbs.slice(-(MAX_VISIBLE - 2));
        return [crumbs[0], null, ...tail];
    };

    render = () => {
        const visible = this.getVisibleCrumbs();
        const total = visible.length;
        if (!total)
            return (
                <WithEvents events={this.event}>
                    <div className='crumbs' />
                </WithEvents>
            );

        return (
            <WithEvents events={this.event}>
                <div className='crumbs'>
                    {visible.map((crumb, index) => {
                        const isLast = index === total - 1;
                        const separator = index > 0 ? <span className='arr'>{'>'}</span> : null;

                        if (crumb === null) {
                            return (
                                <span key='ellipsis' className='crumb-group'>
                                    {separator}
                                    <span className='crumb ellipsis'>&hellip;</span>
                                </span>
                            );
                        }

                        const clickable = !isLast && crumb.route !== undefined;
                        const crumbEl = (
                            <span
                                className={classNames('crumb', isLast && 'current', clickable && 'active')}
                                onClick={clickable ? this.onClickCrumb(crumb) : undefined}
                            >
                                {crumb.label}
                            </span>
                        );

                        if (index === 0) return <React.Fragment key={index}>{crumbEl}</React.Fragment>;
                        return (
                            <span key={index} className='crumb-group'>
                                {separator}
                                {crumbEl}
                            </span>
                        );
                    })}
                </div>
            </WithEvents>
        );
    };
}
